@if (isStarted && hasEstimation) {
    <div class="ticket-recovery has-background-info-fade">
        <div class="recovery-line" (click)="isExpanded = !isExpanded">
            <div class="icon-and-text">
                <span class="icon is-small">
                    <i [ngClass]="isExpanded && 'is-expanded'" class="tri-arrow-up"></i>
                </span>
                <span class="is-uppercase text is-level-3 has-text-weight-bold is-marginless">reprise mobile *</span>
            </div>
            @if (recoveryData.recovery.estimation) {
                <div>
                    <span class="text is-level-3">
                        <trg-price
                            [isInlined]="true"
                            [price]="-totalRecoveryAmount"
                            [size]="'text is-level-2 has-text-weight-semibold is-marginless'"
                            [inheritFontSize]="false"
                        />
                    </span>
                </div>
            }
        </div>
        <div [ngClass]="!isExpanded && 'is-content-hidden'">
            <checkout-ticketline
                label="Valeur estimée"
                [subtitles]="[recoveryData.recovery.product.name]"
                [totalPrice]="recoveryData.recovery.estimation.amount"
                [showPrice]="true"
                [isReprise]="true"
            />
            @if (showBonus) {
                <checkout-ticketline
                    label="Bonus reprise"
                    [totalPrice]="recoveryData.product?.bonus"
                    [showPrice]="true"
                    [isReprise]="true"
                />
            }
            <div class="rows mb-1">
                <div class="row">
                    <div class="columns is-mobile">
                        <div class="column">
                            <a (click)="redirect()" class="link text is-level-3">{{ actionLabel }}</a>
                        </div>
                        <div class="column has-text-right">
                            @if (canDelete && !noButtons) {
                                <a (click)="delete()" class="link text is-level-3">Supprimer</a>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
